import type { LinkComponentProps } from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';
import { Box, Group } from '#core/components';

import styles from './NavLink.module.css';

type NavLinkProps = {
  children: React.ReactNode;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
} & LinkComponentProps;

export const NavLink = ({
  children,
  leftSection,
  rightSection,
  ...props
}: NavLinkProps) => {
  return (
    <Link className={styles.link} {...props}>
      <Group className={styles.group}>
        {leftSection}
        <Box className={styles.label}>{children}</Box>
        {rightSection}
      </Group>
    </Link>
  );
};
